<template>
	<div class="importGood">
		<el-dialog
		  title="导入资源"
		  v-model="visible"
		  :close-on-click-modal="false"
		  width="500px"
		  :visible.sync="visible"
		  :before-close="handleClose"> 
			<el-form v-if="yearNum == '2020'">
				<el-form-item label="文 件 :" label-width="80px">
					<el-upload 
						ref="upload" 
						class="upload-btn" 
						:action="baseUrl+uploadUrl" 
						:accept="fileType" 
						:showFileList="false" 
						:on-success="uploadSuccess" 
						:on-change="uploadChange"
						:before-upload="uploadBefore" 
						:data="upData"
						:disabled="uploading"  
						:auto-upload="false"
						>
						<el-input slot="trigger" type="primary" placeholder="选取文件" v-model="filename"></el-input>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<div class="tip">请上传xlsx,xls,格式文件，大小不超过4M</div>
				</el-form-item>
			</el-form>
			<el-form v-else>
				<el-form-item label="文 件 :" label-width="80px">
					<el-upload 
						ref="upload" 
						class="upload-btn" 
						:action="baseUrl2021+uploadUrl2021" 
						:accept="fileType" 
						:showFileList="false" 
						:on-success="uploadSuccess" 
						:on-change="uploadChange"
						:before-upload="uploadBefore" 
						:data="upData"
						:disabled="uploading"  
						:auto-upload="false"
						>
						<el-input slot="trigger" type="primary" placeholder="选取文件" v-model="filename"></el-input>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<div class="tip">请上传xlsx,xls,格式文件，大小不超过4M</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-link type="primary" :href="baseUrl+downloadUrl" class="mr-10" v-if="yearNum == 2020">下载模板</el-link>
				<el-link type="primary" :href="baseUrl2021+downloadUrl2021" class="mr-10" v-else>下载模板</el-link>
				<el-button type="primary" @click="submitUpload" :loading="upload" v-if="yearNum == 2020">上 传</el-button>
				<el-button type="primary" @click="submitUpload2021" :loading="upload" v-else>上 传</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		contractLocalid: {
			type: Number,
			default: 0
		},
		yearNum:{
			type:String,
			required:true
		},
    currentStatus:{
      type:String,
      required:false,
    },
	},
	data() {
		return {
			baseUrl: '',  // 上传前缀2020
			baseUrl2021: '',  // 上传前缀2021
			uploading: false,  	// 上传中
			fileType:'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',// 导入的文件类型 默认是excel文件
			uploadUrl:'/contractmanager/excelUpAndDown/annualPromotionPlanUpload',						 // 导入接口地址2020
			uploadUrl2021:'/contractmanager/excelUpAndDown/annualPromotionPlanUpload2021',						 // 导入接口地址2021
			downloadUrl:'/contractmanager/excelUpAndDown/annualPromotionPlanModelDownload',						 // 导出模板接口地址2020
			downloadUrl2021:'/contractmanager/excelUpAndDown/annualPromotionPlanModelDownload2021',						 // 导出模板接口地址2021
			filename:'',
			upload:false,
		};
	},
	computed:{
		upData(){
			let contractLocalid = this.contractLocalid;
      let currentStatus = this.currentStatus;
			return {contractLocalid,currentStatus}
		}
	},
	created() {
		this.getBaseUrl();
	},
	methods: {
		getBaseUrl(){
			if(window.IPConfig.HOST && window.IPConfig.HOST != ''){
				this.baseUrl = `${window.IPConfig.IP}:${window.IPConfig.HOST}`;
				this.baseUrl2021 = `${window.IPConfig.IP}:${window.IPConfig.HOST}`;
			}else{
				this.baseUrl = `${window.IPConfig.IP}`;
				this.baseUrl2021 = `${window.IPConfig.IP}`;
			}
		},
		submitUpload(){//手动上传
			this.$refs.upload.submit();
			this.upload = true;
		},
		submitUpload2021(){//手动上传
			this.$refs.upload.submit();
			this.upload = true;
		},
		handleClose() {//关闭
			this.$emit("update:visible", false);
		},
		uploadSuccess(res, file) {// 上传成功的回调
			if(res.code == '200' && res.msg == 'success'){
				this.uploading = false;
				this.upload= false;
				this.$message({
						message: '导入成功！',
						type: 'success'
				});
				this.$emit("update:visible", false);
				this.$emit("refreshQuery");
			}else{
				this.uploading = false;
				this.$message.error(`导入失败 ${res.msg}`);
				this.$emit("update:visible", false);
			}
		},
		uploadChange(file){//选取文件后展示文件名
			this.filename = file.name;
		},
		uploadBefore(file) {// 上传之前的回调
		  this.uploading = true;
			const isLt2M = file.size / 1024 / 1024 < 4;
			if (!isLt2M) {
				this.$message.error('上传文件大小不能超过 4MB!');
				return false;
			}
		}
	}
}
</script>

<style lang="scss">
.importGood{
	.el-form-item__label{
		text-align: left;
		font-size: 14px;
	}
	.mr-10{
		margin-right: 10px;
	}
	.el-input{
		font-size: 14px;
	}
	.tip{
		font-size: 12px;
		color: #999;
	}
	.el-dialog__body{
		padding: 10px 30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/contractmanagement/purchasecontract/add/dialog/importYear.vue